import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { experiments } from "../data/methodsData";

// Leafletning default markeri Webpack/CRA bilan ishlamasligi tufayli o'zimizning ikonkalar
const flagIcon = (url) => new L.Icon({
    iconUrl: url,
    iconSize: [40, 28],
    iconAnchor: [20, 14],
    popupAnchor: [0, -14],
    className: "experiment-flag-icon",
});

function ExperimentsMap() {
    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>Xorijiy tajribalar xaritasi</span></li>
                        </ul>
                        <h2 className="page-header__title">Xorijiy tajribalar — interaktiv xarita</h2>
                    </div>
                </div>
                <img src="/assets/images/page-header-shape-1.png" alt="shape" className="page-header__shape-one" />
                <img src="/assets/images/page-header-shape-2.png" alt="shape" className="page-header__shape-two" />
            </section>

            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Davlatlarni xaritada ko'ring</h3>
                                <p className="pricing-one__text">
                                    Markerlarni bosing — har bir davlatning ta'lim statistikasi va tajribasi ochiladi.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div style={{ height: "550px", borderRadius: "12px", overflow: "hidden", border: "1px solid #eee" }}>
                                <MapContainer
                                    center={[30, 30]}
                                    zoom={2}
                                    style={{ height: "100%", width: "100%" }}
                                    scrollWheelZoom={true}
                                >
                                    <TileLayer
                                        attribution='&copy; OpenStreetMap'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {experiments.map((e) => (
                                        <Marker key={e.id} position={e.coords} icon={flagIcon(e.flag)}>
                                            <Popup>
                                                <div style={{ minWidth: "220px" }}>
                                                    <h4 style={{ margin: "0 0 10px", color: "#ffb606" }}>{e.name}</h4>
                                                    <table style={{ width: "100%", fontSize: "13px" }}>
                                                        <tbody>
                                                            <tr><td><strong>PISA balli:</strong></td><td>{e.pisa}</td></tr>
                                                            <tr><td><strong>O'qituvchi maoshi:</strong></td><td>{e.teacherSalary}</td></tr>
                                                            <tr><td><strong>Ta'lim xarajati:</strong></td><td>{e.eduSpend}</td></tr>
                                                        </tbody>
                                                    </table>
                                                    <p style={{ margin: "10px 0", fontSize: "13px", fontStyle: "italic" }}>
                                                        {e.highlight}
                                                    </p>
                                                    <Link to={e.path} style={{
                                                        display: "inline-block",
                                                        padding: "6px 14px",
                                                        background: "#ffb606",
                                                        color: "#fff",
                                                        borderRadius: "6px",
                                                        textDecoration: "none",
                                                        fontWeight: 600
                                                    }}>
                                                        Batafsil ko'rish →
                                                    </Link>
                                                </div>
                                            </Popup>
                                        </Marker>
                                    ))}
                                </MapContainer>
                            </div>
                        </div>
                    </div>

                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Davlatlar bo'yicha qiyosiy statistika</h3>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div style={{ overflowX: "auto" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr style={{ background: "#ffb606", color: "#fff" }}>
                                            <th style={{ padding: "12px", textAlign: "left" }}>Davlat</th>
                                            <th style={{ padding: "12px" }}>PISA balli</th>
                                            <th style={{ padding: "12px" }}>O'qituvchi maoshi</th>
                                            <th style={{ padding: "12px" }}>Ta'lim xarajati</th>
                                            <th style={{ padding: "12px" }}>Xususiyati</th>
                                            <th style={{ padding: "12px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {experiments.map((e, i) => (
                                            <tr key={e.id} style={{ borderBottom: "1px solid #eee", background: i % 2 ? "#fafafa" : "#fff" }}>
                                                <td style={{ padding: "12px", fontWeight: 600, display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <img src={e.flag} alt={e.name} style={{ width: "32px", height: "22px", objectFit: "cover" }} />
                                                    {e.name}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "center" }}>{e.pisa}</td>
                                                <td style={{ padding: "12px", textAlign: "center" }}>{e.teacherSalary}</td>
                                                <td style={{ padding: "12px", textAlign: "center" }}>{e.eduSpend}</td>
                                                <td style={{ padding: "12px", fontSize: "13px" }}>{e.highlight}</td>
                                                <td style={{ padding: "12px" }}>
                                                    <Link to={e.path} style={{ color: "#ffb606", fontWeight: 600 }}>Batafsil →</Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ExperimentsMap;
